import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ApiService } from '@kidfl/openapi';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VertriebApiStatusService {
  private readonly alertCtrl = inject(AlertController);
  private api = inject(ApiService);

  async checkStatus() {
    try {
      const res = await firstValueFrom(this.api.getHome());
      console.log('test2', res);
    } catch (e) {
      console.log('test');
      const alert = await this.alertCtrl.create({
        header: 'System nicht erreichbar',
        message:
          'Das Vertriebssystem ist zur Zeit nicht erreichbar. Es können keine Bestellungen gemacht werden. Bitte versuchen Sie es später erneut.',
        buttons: [{ text: 'Ok' }],
      });
      await alert?.present();
    }
  }
}
